import React, { useContext, useState } from "react";
import clienteAxios from "../../../config/axios";
import MessageSnackbar from "../../../components/Snackbar/snackbar";
import Spin from "../../../components/Spin/spin";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { NavContext } from "../../../context/context_nav";
import {
  AdquirirCursoGratis,
  AgregarCarritoBD,
  CanjearCupon,
} from "../PeticionesCompras/peticiones_compras";
import { CtxPrincipal } from "../../../context/ContextPrincipal";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  TextField,
  Typography,
} from "@mui/material";

function FormRegistroUsuario(props) {
  const navigate = useNavigate();
  const [datos, setDatos] = useState([]);
  const [checked, setChecked] = useState(false);
  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setError } = useContext(NavContext);
  const [snackbar, setSnackbar] = useState({
    open: false,
    mensaje: "",
    status: "",
  });
  const { setPayment } = React.useContext(CtxPrincipal);
  /* const url = props.match.path.split('/'); */

  const obtenerCampos = (e) => {
    if (e.target.name === "acceptPolicies") {
      setChecked(!checked);
      setDatos({
        ...datos,
        [e.target.name]: e.target.checked,
      });
      return;
    }
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    });
  };

  const obtenerMisCursos = async (user, token) => {
    return await clienteAxios
      .get(`/course/user/${user?._id}`, {
        headers: {
          Authorization: `bearer ${token}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  };

  const enviarDatosBD = async (e) => {
    e.preventDefault();
    if (
      !datos.name ||
      !datos.email ||
      !datos.password ||
      !datos.repeatPassword ||
      !datos.acceptPolicies
    ) {
      setValidate(true);
      return;
    }
    if (datos.password !== datos.repeatPassword) {
      setValidate(true);
      return;
    }
    setLoading(true);
    await clienteAxios
      .post("/user", datos)
      .then((res) => {
        setLoading(false);
        const token = res.data.token;
        const decoded = jwtDecode(token);
        localStorage.setItem("token", token);
        localStorage.setItem("student", JSON.stringify(decoded));

        /* redireccion en caso de ser comprado un curso o aplicar cupon */
        let cuponItem = JSON.parse(localStorage.getItem("coupon"));
        let cartItem = JSON.parse(localStorage.getItem("cart"));
        let buyItem = JSON.parse(localStorage.getItem("buy"));
        let freeItem = JSON.parse(localStorage.getItem("free"));
        let packItem = JSON.parse(localStorage.getItem("pack"));
        if (cuponItem) {
          canjearCupon(cuponItem);
        } else if (cartItem) {
          agregarCarrito(cartItem);
        } else if (buyItem) {
          comprarCurso(buyItem);
        } else if (freeItem) {
          adquirirCursoGratis(freeItem);
        } else if (packItem) {
          props.handleClose();
          navigate(packItem);
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          setSnackbar({
            open: true,
            mensaje: err.response.data.message,
            status: "error",
          });
        } else {
          setSnackbar({
            open: true,
            mensaje: "Al parecer no se a podido conectar al servidor.",
            status: "error",
          });
        }
      });
  };

  const canjearCupon = async ({ curso, cupon, urlActual }) => {
    setLoading(true);
    let token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("student"));

    const result = await CanjearCupon(token, user, curso, cupon);
    if (!result.status || result.status !== 200) {
      setLoading(false);
      localStorage.removeItem("coupon");
      setError({ error: true, message: result });
      navigate(urlActual);
      return;
    }
    setLoading(false);
    localStorage.removeItem("coupon");
    navigate("/mis_cursos");
  };

  const agregarCarrito = async ({ curso, urlActual }) => {
    setLoading(true);
    let token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("student"));

    const result = await AgregarCarritoBD(token, user, curso);
    if (!result.status || result.status !== 200) {
      setLoading(false);
      localStorage.removeItem("cart");
      setError({ error: true, message: result });
      navigate(urlActual);
      return;
    }
    setLoading(false);
    localStorage.removeItem("cart");
    navigate("/carrito");
  };

  const comprarCurso = async ({ curso, urlActual }) => {
    setLoading(true);
    let user = JSON.parse(localStorage.getItem("student"));

    localStorage.removeItem("buy");
    setPayment({
      user,
      courses: curso,
    });
    /* localStorage.setItem("payment",
      JSON.stringify({
        user: user,
        courses: curso,
      })
    ); */

    /* setTimeout(() => {
      navigate(`/compra/${curso[0].course.slug}`)
		}, 500); */
    setTimeout(() => {
      navigate("/compra");
    }, 500);
  };

  const adquirirCursoGratis = async ({ curso, urlActual }) => {
    setLoading(true);
    let token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("student"));
    let course = false;

    const misCursos = await obtenerMisCursos(user, token);

    /* verificar si ya tienes el curso */
    misCursos.forEach((res) => {
      if (res.idCourse._id === curso._id) {
        course = true;
      }
      return;
    });
    if (course) {
      setLoading(false);
      localStorage.removeItem("free");
      setTimeout(() => {
        navigate(`/dashboard/${curso.slug}`);
      }, 500);
      return;
    }
    const result = await AdquirirCursoGratis(curso, user, token);
    if (result.status && result.status === 200) {
      setLoading(false);
      localStorage.removeItem("free");
      navigate("/mis_cursos");
    } else {
      localStorage.removeItem("free");
      setLoading(false);
      setError({ error: true, message: result });
      navigate(urlActual);
      return;
    }
  };

  return (
    <Box>
      <Spin loading={loading} />
      <MessageSnackbar
        open={snackbar.open}
        mensaje={snackbar.mensaje}
        status={snackbar.status}
        setSnackbar={setSnackbar}
      />
      <Box my={1}>
        <Typography variant="h6" align="center">
          Ingresa tus datos
        </Typography>
      </Box>
      <Box px={5}>
        <Divider />
      </Box>
      <Box px={5}>
        <form onSubmit={enviarDatosBD}>
          <Box my={2}>
            <TextField
              error={!datos.name && validate}
              helperText={
                !datos.name && validate ? "Este campo es requerido" : null
              }
              fullWidth
              required
              id="mombre"
              name="name"
              label="Nombre"
              onChange={obtenerCampos}
            />
          </Box>
          <Box my={2}>
            <TextField
              error={!datos.email && validate}
              helperText={
                !datos.email && validate ? "Este campo es requerido" : null
              }
              fullWidth
              required
              id="email"
              name="email"
              label="Email"
              onChange={obtenerCampos}
            />
          </Box>
          <Box my={2}>
            <TextField
              error={
                validate
                  ? !datos.password
                    ? true
                    : datos.password !== datos.repeatPassword
                      ? true
                      : false
                  : false
              }
              helperText={
                validate
                  ? !datos.password
                    ? "Este campo es requerido"
                    : datos.password !== datos.repeatPassword
                      ? "Las contraseñas no coinciden"
                      : null
                  : null
              }
              fullWidth
              required
              id="password"
              name="password"
              label="Contraseña"
              type="password"
              onChange={obtenerCampos}
            />
          </Box>
          <Box my={2}>
            <TextField
              error={
                validate
                  ? !datos.repeatPassword
                    ? true
                    : datos.password !== datos.repeatPassword
                      ? true
                      : false
                  : false
              }
              helperText={
                !datos.repeatPassword && validate
                  ? "Este campo es requerido"
                  : datos.password !== datos.repeatPassword
                    ? "Las contraseñas no coinciden"
                    : null
              }
              fullWidth
              required
              id="repeatPassword"
              name="repeatPassword"
              label="Repite tu contraseña"
              type="password"
              onChange={obtenerCampos}
            />
          </Box>
          <Box my={2}>
            <FormControl error={!datos.acceptPolicies && validate}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    name="acceptPolicies"
                    color="primary"
                    onChange={obtenerCampos}
                  />
                }
                label={
                  <Typography>
                    <Link target="_blank" href="/politicas">
                      Acepto políticas y condiciones
                    </Link>
                  </Typography>
                }
              />
              <FormHelperText id="my-helper-text">
                Acepta las políticas para registrarte.
              </FormHelperText>
            </FormControl>
          </Box>
          <Box mt={5} mb={2}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary" /* onClick={() => enviarDatosBD()} */
            >
              Crear cuenta
            </Button>
            <Box my={1} />
            <Button fullWidth component={Link} to="/login">
              ¿Ya tienes cuenta? Inicia sesión aquí
            </Button>
          </Box>
        </form>

        {/* {url[1] === 'registro' ? (
						<Fragment>
							<Divider />
							<Box display="flex" justifyContent="center" mt={2}>
								<Button variant="contained" color="secondary" component={Link} to="/login">
									Iniciar sesión con Google o Facebook
								</Button>
							</Box>
						</Fragment>
					) : null} */}
        {/* {url[1] === 'registro' ? (
						<Fragment>
							<Divider />
							<Box my={2} textAlign="center">
								<Typography variant="h6">Crear una cuenta con Google o Facebook</Typography>
								<Firebase />
							</Box>
						</Fragment>
						
					) : null} */}
      </Box>
    </Box>
  );
}
export default FormRegistroUsuario;
